/**
 * Estimates the token volume represented by visible streamed text.
 *
 * Provider usage is not always available in live UI events, so this uses the
 * common ~4 characters per token display heuristic until exact usage arrives.
 */
export function estimateDisplayTokenCount(text: string): number {
  const compactText = text.trim().replace(/\s+/g, " ");
  if (!compactText) return 0;
  return Math.max(1, Math.ceil(compactText.length / 4));
}
